import React from "react";
import PromineoModalWithLoader from "components/common/controls/modal/PromineoModalWithLoader";

interface Props {
  children: React.ReactChild;
  title: string;
  onClose: () => void;
  isLoading: boolean;
}

export default function EditorModal(props: Props) {
  const { title, children, onClose, isLoading } = props;
  return (
    <PromineoModalWithLoader
      isLoading={isLoading}
      title={title}
      visible={true}
      onClose={onClose}
      maxWidth="471px"
      height="auto"
      displayDefaultActions={false}
    >
      {children}
    </PromineoModalWithLoader>
  );
}
